import { render, staticRenderFns } from "./PaymentTransportersCollect.vue?vue&type=template&id=68b75109&scoped=true"
import script from "./PaymentTransportersCollect.vue?vue&type=script&lang=js"
export * from "./PaymentTransportersCollect.vue?vue&type=script&lang=js"
import style0 from "./PaymentTransportersCollect.vue?vue&type=style&index=0&id=68b75109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b75109",
  null
  
)

export default component.exports